import axios from "axios";

import { SERVER_BASE_URL } from "../constants";

const apiClient = axios.create({
  baseURL: SERVER_BASE_URL,
});

export default apiClient;
